<template>
  <div class="auto-link-text">
    <template v-for="(part, index) in parsedText" :key="index">
      <a
        v-if="part.isLink"
        :href="part.text"
        target="_blank"
        rel="noopener noreferrer"
        class="link"
      >
        {{ part.text }}
      </a>
      <span v-else>{{ part.text }}</span>
    </template>
  </div>
</template>

<script setup lang="ts">
/**
 * Purpose: Render plain announcement text with safe text interpolation while preserving line breaks
 * and turning explicit HTTP(S) URLs into external links.
 */
import { computed } from 'vue'

interface Props {
  text: string
}

const props = defineProps<Props>()

// URL 正则表达式
const urlRegex = /(https?:\/\/[^\s]+)/g

const parsedText = computed(() => {
  if (!props.text) return []

  const parts: Array<{ text: string; isLink: boolean }> = []
  let lastIndex = 0
  let match

  while ((match = urlRegex.exec(props.text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({
        text: props.text.substring(lastIndex, match.index),
        isLink: false,
      })
    }

    parts.push({
      text: match[0],
      isLink: true,
    })

    lastIndex = match.index + match[0].length
  }

  if (lastIndex < props.text.length) {
    parts.push({
      text: props.text.substring(lastIndex),
      isLink: false,
    })
  }

  return parts
})
</script>

<style lang="less" scoped>
.auto-link-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;

  .link {
    color: #1890ff;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      border-radius: 2px;
      outline: 2px solid currentColor;
      outline-offset: 2px;
    }
  }
}
</style>
